import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isSuperadminAuthenticated: undefined,
    superadminData: null
}

const superadminAuth = createSlice({
    name: "superadmin",
    initialState,
    reducers: {
        superadminLogin: (state, action) => {
            state.isSuperadminAuthenticated = true,
            state.superadminData = action.payload?.data
        },
        superadminLogout: (state) => {
            state.isSuperadminAuthenticated = false,
            state.superadminData = null
        }
    }
})

export const {superadminLogin, superadminLogout} = superadminAuth.actions
export default superadminAuth.reducer